import { Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'
import injectSheet from 'react-jss'

const styles = {
	topRightButton: {
		position: 'absolute !important',
		top: '0',
		right: '0',
		'margin-right': '0 !important',
		'border-top-right-radius': '0 !important',
		'border-top-left-radius': '0 !important',
		'border-bottom-right-radius': '0 !important'
	}
}
function BackLink({ icon, classes, content, to, onClick }) {
	const button = (
		<Button
			secondary
			onClick={onClick}
			icon={icon}
			labelPosition="left"
			content={content}
			size="small"
			className={classes.topRightButton}
		/>
	)
	if (to) {
		return (
			<Link to={to}>
				{button}
			</Link>
		)
	}
	return button
}
BackLink.propTypes = {
	classes: PropTypes.object.isRequired,
	icon: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	to: PropTypes.string,
	onClick: PropTypes.func
}
BackLink.defaultProps = {
	icon: 'reply',
	content: 'back'
}

export default injectSheet(styles)(BackLink)



// WEBPACK FOOTER //
// ./src/components/BackLink.js